import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header/Header';
import Reels from './pages/Reels';
import ProductDetail from "./pages/ProductDetail";

import Admin from './pages/Admin';
import Agent from './pages/Agent';
import Vendor from './pages/Vendor';
import Customer from './pages/Customer';
import Login from './components/Login/Login';
import AdminRegistration from './components/Registration/AdminRegistration';
import AgentRegistration from './components/Registration/AgentRegistration';
import VendorRegistration from './components/Registration/VendorRegistration';
import CustomerRegistration from './components/Registration/CustomerRegistration';
import ProfilePage from './pages/ProfilePage';
import useGeolocation from './components/geolocation/useGeolocation';
import VendorDashboard from './pages/vendor/Dashboard';
import AgentDashboard from './pages/AgentDashboard';
import CustomerDashboard from './pages/CustomerDashboard';
import AddProduct from './pages/vendor/AddProduct';
import VendorProductList from './pages/vendor/VendorProductList';
import AddNewProduct from './pages/vendor/AddNewProduct';
import { CartProvider } from "./context/CartContext";
import CartPage from "./pages/CartPage";
import CheckoutPage from "./pages/CheckoutPage";
import OrderSummary from "./pages/OrderSummary";
import PaymentPage from "./pages/PaymentPage";
import WishlistPage from "./pages/WishlistPage";
import CartDrawer from "./components/CartDrawer";
import DeliveryLocation from "./pages/DeliveryLocation";
// import PaymentPage from "./pages/checkout/PaymentPage";
import OrderSuccess from "./pages/OrderSuccess";
import CustomerOrders from "./customer/CustomerOrders";
import OrderDetails from "./customer/OrderDetails";
import VendorOrders from "./pages/vendor/VendorOrders";
import VendorOrderDetails from "./pages/vendor/VendorOrderDetails";
import VendorStore from "./pages/vendor/VendorStore";
import ForgotPassword from './components/Login/ForgotPassword';
import Layout from "./Layout";
import { SnackbarProvider } from "./utils/SnackbarProvider";
import SearchPage from './components/Header/SearchPage';
import VendorReviews from './pages/vendor/VendorReviews';
import ArchivedProducts from './pages/vendor/ArchivedProducts';
import VendorStorePolicy from './pages/vendor/VendorStorePolicy'; 
// -----------------------------------------
// 📌 Checkout Guards (Uncomment when needed)
// -----------------------------------------
// import {
//   DeliveryGuard,
//   SummaryGuard,
//   PaymentGuard,
//   SuccessGuard,
// } from "./guards/CheckoutGuards";
// -----------------------------------------
// 📌 Location Permission Popup Component
// -----------------------------------------
// import LocationPopup from "./components/geolocation/LocationPopup"; 
// You need a popup UI component

function App() {
  const {  error,  } = useGeolocation();
  const [showLocationPopup, setShowLocationPopup] = useState(false);

  useEffect(() => {
    if (error === "User denied Geolocation") {
      setShowLocationPopup(true);
    }
  }, [error]);

  return (
    <SnackbarProvider>
    <Router>
      {/* {showLocationPopup && (
        <LocationPopup onAllow={handleAllow} onDeny={handleDeny} />
      )} */}

      {!showLocationPopup && (
        <>
        <CartProvider>
          {/* <Header /> */}
          {/* <CartDrawer /> */}
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Reels />} />
              <Route path="/product/:id" element={<ProductDetail />} />
              <Route path="/delivery-location" 
                    element={ // <DeliveryGuard>
                    <DeliveryLocation />
                  // </DeliveryGuard>
                }
              />
              <Route
                path="/order-summary"
                element={
                  // <SummaryGuard>
                    <OrderSummary />
                  // </SummaryGuard>
                }
              />
              <Route
                path="/payment"
                element={
                  // <PaymentGuard>
                    <PaymentPage />
                  // </PaymentGuard>
                }
              />
              <Route
                path="/order-success"
                element={
                  // <SuccessGuard>
                    <OrderSuccess />
                  // </SuccessGuard>
                }
              />
            <Route path="/wishlist" element={<WishlistPage />} />
            <Route path="/customer/orders" element={<CustomerOrders />} />
            <Route path="/customer/orders/:orderId" element={<OrderDetails />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/agent" element={<Agent />} />
            <Route path="/vendor" element={<Vendor />} />
            <Route path="/customer" element={<Customer />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register/admin" element={<AdminRegistration />} />
            <Route path="/register/agent" element={<AgentRegistration />} />
            <Route path="/register/vendor" element={<VendorRegistration />} />
            <Route path="/register/customer" element={<ProfilePage />} />
             <Route path="/vendor/dashboard" element={<VendorDashboard />} />
            <Route path="/customer/dashboard" element={<CustomerDashboard />} />
            <Route path="/agent/dashboard" element={<AgentDashboard />} />

            <Route path="/vendor/add-product" element={<AddProduct />} />
            <Route path="/vendor/add-product" element={<AddProduct />} />
            <Route path="/vendor/products" element={<VendorProductList />} />
            <Route path="/vendor/products/new" element={<AddNewProduct />} />
            <Route path="/vendor/orders" element={<VendorOrders />} />
            <Route path="/vendor/orders/:orderId" element={<VendorOrderDetails />} />
            <Route path="/vendor/policies" element={<VendorStorePolicy />} />

            <Route path="/cart" element={<CartPage />} />
            <Route path="/checkout" element={<CheckoutPage />} />

            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path="/vendor/edit-product/:id" element={<AddNewProduct />} />
            <Route path="/store/:vendorId" element={<VendorStore />} />
            <Route path="/vendor/:vendorId/reviews" element={<VendorReviews />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/search" element={<SearchPage />} />
            <Route
              path="/vendor/products/archived"
              element={<ArchivedProducts />}
            />
            </Route>          
          </Routes>
        </CartProvider>
        </>
      )}
    </Router>
    </SnackbarProvider>
  );
}

export default App;
